// TEST with https://one.accuweather.com/app?location-permission=always&locations-current=-77.8977,40.78172

// Coordinates of locations to show messages for
const messageLocations = {
	type: 'FeatureCollection',
	features: [
		{
			type: 'Feature',
			properties: {
				image:
					'https://cms.accuweather.com/wp-content/uploads/2025/10/met-eu-dark.png',
				alt: 'Meteorological Technology World Expo logo',
				message: '<p>Come learn more about AccuWeather Lightning Network at <b>Booth A526</b>!</p> <p>Click to see the VIECON forecast.</p>',
			},
			geometry: {
				coordinates: [
					[
						[16.40904470925372, 48.217336639875185],
						[16.406249345743902, 48.21781517257435],
						[16.405680614211377, 48.21610230715953],
						[16.406772578752907, 48.21573850535705],
						[16.40637446668066, 48.21542017665902],
						[16.408467398718415, 48.21438180500698],
						[16.408763139115592, 48.214616766859706],
						[16.41010534553064, 48.21387398054631],
						[16.409729982719256, 48.213449526386626],
						[16.41182291475701, 48.21230499852854],
						[16.413654230290348, 48.21374512876247],
						[16.414791693354374, 48.21402557046494],
						[16.411754666973707, 48.215639975257176],
						[16.41058308001797, 48.21658737220844],
						[16.40904470925372, 48.217336639875185],
					],
				],
				type: 'Polygon',
			},
			id: 'meteu',
		},
		{
			type: 'Feature',
			properties: {
				image:
					'https://www.accuweather.com/images/logos/accuweather-superior-accuracy-light.svg',
				alt: 'AccuWeather Logo',
				message: 'Welcome to AccuWeather Headquarters!',
			},
			geometry: {
				coordinates: [
					[
						[-77.89773746451372, 40.78172441454993],
						[-77.89657729184968, 40.780471332826124],
						[-77.89532289196426, 40.78097970334997],
						[-77.89668329747407, 40.78233533905984],
						[-77.89773746451372, 40.78172441454993],
					],
				],
				type: 'Polygon',
			},
			id: 'sce',
		},
	],
};

// Both the cookie and query parameter can contain the longitude,latitude pair of the user's coordinates.
// If both are present, the query parameter takes precedence.
const queryParameter = 'locations-current';
const cookieName = 'awx_current_location';

const parseCoordinatePair = (value) => {
	if (!value) return null;
	const [lonStr, latStr] = value.split(',').map((part) => part.trim());
	const lon = Number.parseFloat(lonStr);
	const lat = Number.parseFloat(latStr);
	return Number.isFinite(lon) && Number.isFinite(lat) ? { lon, lat } : null;
};

const getCoordinatesFromQuery = () => {
	const params = new URLSearchParams(window.location.search);
	return params.has(queryParameter)
		? parseCoordinatePair(params.get(queryParameter))
		: null;
};

const getCoordinatesFromCookie = () => {
	const cookies = document.cookie.split(';').map((entry) => entry.trim());
	const target = cookies.find((entry) => entry.startsWith(`${cookieName}=`));
	if (target) {
		// Parse the cookie as an encoded JSON
		// Like %5B-77.8977%2C40.78172%5D
		const decoded = decodeURIComponent(target.split('=')[1]);
		try {
			const array = JSON.parse(decoded);
			return { lon: array[0], lat: array[1] };
		} catch (e) {
			console.error('Failed to parse cookie:', e);
		}
	}
	return null;
};

const testIntersection = ({ lon, lat }, coordinates) => {
	// Ray-casting algorithm to determine if point is in polygon
	const x = lon,
		y = lat;
	let inside = false;
	for (let i = 0, j = coordinates.length - 1; i < coordinates.length; j = i++) {
		const xi = coordinates[i][0],
			yi = coordinates[i][1];
		const xj = coordinates[j][0],
			yj = coordinates[j][1];
		if (yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi) {
			inside = !inside;
		}
	}
	return inside;
};

const showLocationPopup = ({ image, alt, message }) => {
	const popup = document.createElement('div');
	const content = document.createElement('div');
	const closeIcon = document.createElement('span');
	const logo = document.createElement('img');
	const messageNode = document.createElement('p');
	const submessageNode = document.createElement('p');
	popup.style.cssText = `
		position: fixed;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0,0,0,0.3);
		z-index: 9999;
		backdrop-filter: blur(4px);
	`;
	content.style.cssText = `
		position: relative;
		background: #eae9e1;
		color: #000;
		padding: 24px 32px;
		border-radius: 8px;
		box-shadow: 0 12px 32px rgba(0,0,0,0.25);
		text-align: center;
		max-width: 320px;
		display: flex;
		flex-direction: column;
		align-items: center;
	`;
	logo.src = image;
	logo.alt = alt;
	logo.style.cssText = 'max-width: 150px; margin-bottom: 12px;';
	messageNode.innerHTML = message;
	messageNode.style.cssText = 'font-size: 18px; display: flex; flex-direction: column; align-items: center; gap: 8px;';
	submessageNode.textContent = 'Tap anywhere to dismiss';
	submessageNode.style.cssText =
		'margin-top: 8px; font-size: 12px; opacity: 0.6; font-style: italic;';
	closeIcon.textContent = 'X';
	closeIcon.style.cssText = `
		position: absolute;
		top: 12px;
		right: 18px;
		height: 18px;
		width: 18px;
		border: solid 1px #cf0a0a88;
		line-height: 18px;
		background: #cf0a0a22;
		border-radius: 50%;
		opacity: 0.8;
		font-size: 12px;
		color: #cf0a0a;
	`;
	content.append(logo, messageNode, closeIcon);
	popup.appendChild(content);
	const removePopup = () => popup.remove();
	popup.addEventListener('click', removePopup, { once: true });
	document.body.appendChild(popup);
	setTimeout(() => popup.isConnected && removePopup(), 10000);
};

function startGeoPopup() {
	const localStorageKey = 'shown_features';
	const shownFeatures = localStorage.getItem(localStorageKey) ?? '';
	const homepage =
		window.location.pathname === '/app' ||
		window.location.pathname === '/app/today';
	if (homepage) {
		const coordinates =
			getCoordinatesFromQuery() || getCoordinatesFromCookie();
		if (coordinates) {
			const matched = messageLocations.features
				.filter(({ id }) => !shownFeatures.includes(id))
				.find(({ geometry }) =>
					testIntersection(coordinates, geometry.coordinates[0]),
				);
			if (matched) {
				showLocationPopup(matched.properties);
				localStorage.setItem(
					localStorageKey,
					shownFeatures + ',' + matched.id,
				);
			}
		}

	}
}

try {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => {
			startGeoPopup();
		});
	} else {
		startGeoPopup();
	}
} catch (e) {
	console.error('METEU: Error during geolocation processing', e);
}
